
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bms",
      function () {
        return require("private-next-pages/bms.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bms"])
      });
    }
  